import { useEffect, useState } from "react";
import { VALIDATION_ERROR } from "../../app/errors";
import { ErrorWithString } from "../RegularComponents";
import DateSelectionForm from "../../components/DateSelectionForm";

const MRAWorkHistoryDetailsForm = (props) => {
  const {
    startDate,
    duration,
    description,
    index,
    onSaveItem,
    validationError,
  } = props;

  const [workStartDate, setWorkStartDate] = useState(startDate);
  const [workDuration, setWorkHistoryDuration] = useState(duration);
  const [workDescription, setWorkHistoryDescription] = useState(description);

  const [showValidationError, setShowValidationError] =
    useState(validationError);

  const [durationError, setDurationError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [descriptionError, setDescriptionError] = useState(
    VALIDATION_ERROR.NO_ERROR
  );

  useEffect(() => {
    const validateDuration = () => {
      if (!workDuration) {
        setDurationError(VALIDATION_ERROR.EMPTY);
      } else {
        setDurationError(VALIDATION_ERROR.NO_ERROR);
      }
    };

    const validateDescription = () => {
      if (!workDescription) {
        setDescriptionError(VALIDATION_ERROR.EMPTY);
      } else {
        setDescriptionError(VALIDATION_ERROR.NO_ERROR);
      }
    };

    if (showValidationError) {
      validateDuration();
      validateDescription();
    }
  }, [
    workDuration,
    workDescription,
    durationError,
    descriptionError,
    showValidationError,
  ]);

  return (
    <>
      <div className="row">
        <div className="col-lg-4">
          <fieldset className="ns-fieldset"></fieldset>
        </div>
      </div>
      {/* {Need to put in startDate duration & description here} */}
      {/* Date */}
      <div className="row">
        <div className="col-lg-8">
          <fieldset className="ns-fieldset">
            <label
              id="upload-work-history-start-date-label"
              className="ns-label"
            >
              Start Date
            </label>
            <p>Enter a Day Month Year. For example 17 11 2007</p>
            <DateSelectionForm
              id={"upload-work-history-start-date"}
              date={workStartDate}
              onDateChange={(date) => {
                setWorkStartDate(date);
                if (date > 0) {
                  onSaveItem(index, date, "startDate");
                }
              }}
            />
          </fieldset>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8">
          <fieldset className="ns-fieldset">
            <label
              id={"upload-work-history-duration-label"}
              className="ns-label"
              htmlFor={"upload-work-history-duration-text"}
            >
              Duration
            </label>
            {durationError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"upload-work-history-duration-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(durationError)}
              </span>
            )}
            <input
              type="text"
              className={"fw-25 ns-input"}
              id={"upload-work-history-duration-text"}
              name={"upload-work-history-duration-text"}
              value={workDuration}
              onChange={(e) => {
                setWorkHistoryDuration(e.target.value);
              }}
              onBlur={() => {
                setShowValidationError(true);
                onSaveItem(index, workDuration, "duration");
              }}
            />
          </fieldset>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8">
          <fieldset className="ns-fieldset">
            <label
              id={"upload-work-history-description-label"}
              className="ns-label"
              htmlFor={"upload-work-history-description-text"}
            >
              Description
            </label>
            {descriptionError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"upload-work-history-description-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(descriptionError)}
              </span>
            )}
            <textarea
              type="text"
              className={"fw-25 ns-input"}
              id={"upload-work-history-description-text"}
              name={"upload-work-history-description-text"}
              value={workDescription}
              onChange={(e) => {
                setWorkHistoryDescription(e.target.value);
              }}
              onBlur={() => {
                onSaveItem(index, workDescription, "description");
              }}
            />
          </fieldset>
        </div>
      </div>
    </>
  );
};

export default MRAWorkHistoryDetailsForm;
